import './App.css';
import { Fade } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";

const fadeImages = [
  require("./assets/1.5.png"),
  require("./assets/S1.png"),
  require("./assets/S2.png"),
  require("./assets/S4.png"),
  require("./assets/S5.png"),
  require("./assets/S7.png"),
  require("./assets/S8.png"),
];

function App() {
  return (
    <div className="App">
      <header className="container main_header">
        <div className="row d-flex justify-content-between">
          <div className="col-lg-3 col-sm-12">
            <a href="https://metalok.io" target={'_blank'}><img className="logo_img" src={require('./assets/logo.png')} /></a>
          </div>
          <div className="col-lg-3 col-sm-12">
            <a href="#" ><img className="logo_img" src={require('./assets/logo3.png')} /></a>
          </div>
          {/* <div className="col-lg-3 col-sm-12 main_navigation float-lg-end">
          </div> */}
        </div>
      </header>

      <section className="container">
        <div className="row project_container">
          <div className="col-lg-12 col-sm-12 project_content d-flex justify-content-center">
            <div className="col-lg-6 headline">
              Avalipt Studios
            </div>
          </div>
        </div>
      </section>

      <section className="container ">
        <div className="row project_container">
          <div className="col-lg-6 col-sm-12 project_content">
            <p>
              Metalok and Avalipt share the same vision, where customization and user-centric approach takes the lead. And bringing them together has been a fun and rewarding process. In our metaverse, we are designing a virtual store for Avalipt that evinces their brand identity of ‘hand painted luxury’.
              The store façade of a paintbrush, interiors like descending angel installation, furnishings and facilities in our Avalipt virtual store reflect artistry, luxury, sophistication and customization (Avalipt’s philosophy of Indian artists working on individual products bearing in mind the wearer’s identity) of the brand.
              Our store is designed to showcase luxury formal shirts and denims created by Avalipt, with a facility to virtually try them on in our trial rooms. We also have in plan, a lounge space and a design studio which are still in conceptualization phase.
              All-in-all, in our Metalok metaverse, we would like to give the users, an Avalipt store experience as close to reality as possible.
            </p>
          </div>
          <div className="col-lg-6 col-sm-12 text-end">
            <img src={require('./assets/1.5.png')} className="section_img sportsverse" />
          </div>
        </div>
      </section>

      <br></br>
      <br></br>

      <div className="container d-flex justify-content-center">
        <iframe width="100%" height="500px" allowFullScreen="true" allow="accelerometer; magnetometer; gyroscope" src="https://panoraven.com/en/embed/csBL5viotM"></iframe>
      </div>

      <br></br>

      <section className="container">
        <div className="row project_container">
          <div className="col-lg-12 col-sm-12 project_content d-flex justify-content-center">
            <div className="col-lg-6 headline">
              Road To The Studio!!
            </div>
          </div>
        </div>
      </section>

      <section className="container ">
        <div className="row project_container">
          <div className="col-lg-6 col-sm-12 text-end">
            <img src={require('./assets/1.2.png')} className="section_img sportsverse" />
          </div>
          <div className="col-lg-6 col-sm-12 project_content">
            <h1 className="headline">
              Conceptualization!!
            </h1>
            <p>
              Avalipt virtual store is conceptualized to reflect the brand identity of ‘hand painted luxury’. Luxurious décor brought in by modern and subtle elements, and colour palette of White, Gold and black which are the colours of Avalipt, become the visual manifestation of the company’s branding. To add the essence of casual that still upholds the Avalipt brand value of luxury, the denim section of the store is constituted with graffiti elements and art. We have thus succeeded in incorporating the street gothic and dark theme into the sophisticated concept of Avalipt through our Avalipt’s virtual store in Metalok’s metaverse.
            </p>
          </div>
        </div>
      </section>

      <section className="container ">
        <div className="row project_container">
          <div className="col-lg-6 col-sm-12 project_content">
            <h1 className="headline">
              Design!!
            </h1>
            <p>
              The store’s layout and design are filled with elements that transform the concept into the visual spectacle i.e. the Avalipt Virtual Store in our Metaverse. The glass façade adorned with the paintbrush is a clear co-relation of the store with the brand identity of ‘hand-painting’. We have also used sophisticated and grand materials like Italian marble and gold-pleated stands reflecting the luxurious style of Avalipt. Strip lights with warm lightings and self-lit hangings integrated into the design give an ethereal outlook to the store. Traversing into the denim section of the store, the graffiti wall mural of a woman is our The highlight of our store design, though, is the descending angel installation basking in drop lights, that holds the significance of representing the ‘customization’ facet of Avalipt. Like the guardian angel protecting every individual, Avalipt, with their team of talented Indian artists hand-paints an individual focused design depicting the wearer’s identity.
            </p>
          </div>
          <div className="col-lg-6 col-sm-12 text-end">
            <div className="slide-container">
              <Fade>
                <div className="each-fade">
                  <img src={fadeImages[0]} />
                </div>
                <div className="each-fade">
                  <img src={fadeImages[1]} />
                </div>
                <div className="each-fade">
                  <img src={fadeImages[2]} />
                </div>
                <div className="each-fade">
                  <img src={fadeImages[3]} />
                </div>
                <div className="each-fade">
                  <img src={fadeImages[4]} />
                </div>
                <div className="each-fade">
                  <img src={fadeImages[5]} />
                </div>
                <div className="each-fade">
                  <img src={fadeImages[6]} />
                </div>
              </Fade>
            </div>
          </div>
        </div>
      </section>

      <section className="container ">
        <div className="row project_container">
          <div className="col-lg-6 col-sm-12 text-end">
            <iframe width="100%" height="500px" allowFullScreen="true" allow="accelerometer; magnetometer; gyroscope" src="https://panoraven.com/en/embed/csBL5viotM"></iframe>
          </div>
          <div className="col-lg-6 col-sm-12 project_content">
            <h1 className="headline">
              VR Ready!!
            </h1>
            <p>
              Experience the grandness, feel the elegance and walkthrough the different sections of the virtual Avalipt store in our Metaverse through the 360 degree virtual tour. In the future, we plan to enable the tour with VR capabilities for a better user experience.
            </p>
          </div>
        </div>
      </section>

      <section className="container ">
        <div className="row project_container">
          <div className="col-lg-6 col-sm-12 project_content">
            <h1 className="headline">
              Studio Walkthrough!!
            </h1>
            <p>
              Overlooking an ample parking space, stands the Avalipt’s store front with elegant glass façade. The paint brush elevation of the building is the identification of the store that leads to an elegant Reception area with the backdrop of Avalipt’s brand name, logo and tag-line.
              To the left of the reception area we have a space dedicated to the collaborative branding of Avalipt with our company, Metalok. In this area, with our logo gracing the back wall, Metalok’s virtual avatar, Zen, will model Avalipt’s luxury wear. Adjacent to the station, we designed a palette shaped shelf displaying the clothes. The angel installation takes the centre stage along with the seating.
              The denim wear has a dedicated space in this store decorated with creative denim wall murals, graffiti and installations. The hanging bike installation grabs the customer’s attention primarily with a seating space just below it. The side walls of the room are made aesthetically pleasing with mirrors attached to them reflecting the lighting and visual elements of the room.
            </p>
          </div>
          <div className="col-lg-6 col-sm-12 text-end">
            <img src={require('./assets/coming-soon-see-it-soon.gif')} className="section_img sportsverse" />
          </div>
        </div>
      </section>

      <section className="container ">
        <div className="row project_container">
          <div className="col-lg-6 col-sm-12 text-end">
            <img src={require('./assets/coming-soon-see-it-soon.gif')} className="section_img sportsverse" />
          </div>
          <div className="col-lg-6 col-sm-12 project_content">
            <h1 className="headline">
              Populating the Studio!!
            </h1>
            <p>
              All the aesthetic elements and purpose of our virtual store is to the serve the customer’s needs. In Avalipt’s virtual store in our metaverse, users can look into the premium Avalipt’s clothes displayed in the store, try them on their avatar in the virtual trial rooms or sit and enjoy the store’s ambience. Get the unique experience of the Avalipt’s store in the virtual world from the comfort and convenience of your own physical space with the integration of the concept of the metaverse.
            </p>
          </div>
        </div>
      </section>

      <br></br>

      <footer className="container main_header">
        <b>**All the designs and devlopments are for concept purposes and are the property of Metalok Solutions Private Ltd.**</b>
      </footer>
    </div>
  );
}

export default App;
